import {createContext} from 'react'

export const RuntimeContext = createContext<any>({
  host: {
    dimensions: {},
  },
})
